export var EmissorPaymentMethod;
(function (EmissorPaymentMethod) {
    EmissorPaymentMethod["ACCOUNT_BALANCE"] = "ACCOUNT_BALANCE";
    EmissorPaymentMethod["PIX"] = "PIX";
    EmissorPaymentMethod["BANK_SLIP"] = "BANK_SLIP";
})(EmissorPaymentMethod || (EmissorPaymentMethod = {}));
